export default __webpack_public_path__ + "static/media/hackviolet.d3bf49af.png";